// Small touches: a squishy peeks out of a brand tile on hover, and a
// squishy hops on the footer line when the visitor reaches the bottom.
(() => {
  const sprites = window.squishystartzSprites;
  const makeSprite = (className) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('shape-rendering', 'crispEdges');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('class', className);
    svg.style.color = sprites.randomColour();
    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttribute('href', `#sq-${sprites.randomFace()}`);
    svg.appendChild(use);
    return svg;
  };

  // Brand tiles: a random squishy pops up on hover
  document.querySelectorAll('.collection-card-wrapper').forEach((tile) => {
    // Fallback: a click anywhere on the tile opens its collection
    const link = tile.querySelector('a.full-unstyled-link');
    if (link) {
      tile.style.cursor = 'pointer';
      tile.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;
        window.location.href = link.href;
      });
    }

    const peek = makeSprite('sq-peek');
    tile.appendChild(peek);
    tile.addEventListener('mouseenter', () => {
      peek.style.color = sprites.randomColour();
      peek.querySelector('use').setAttribute('href', `#sq-${sprites.randomFace()}`);
    });
  });

  // Footer: a squishy hops when the bottom of the page comes into view
  const footer = document.querySelector('.footer');
  if (footer && 'IntersectionObserver' in window) {
    const hopper = makeSprite('sq-footer-hop');
    const strip = document.createElement('div');
    strip.className = 'sq-footer-strip';
    strip.appendChild(hopper);
    footer.prepend(strip);
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        hopper.classList.remove('is-hopping');
        void hopper.offsetWidth;
        hopper.classList.add('is-hopping');
      }
    }, { threshold: 0.3 });
    observer.observe(footer);
  }
})();
